<template>
  <div>
    <div class="no">
      <div class="no-hd" style="background-color: rgba(255, 255, 255, 0.1);">
        <ul>
          <li :class="{'em-run':isRun_n,'em-stop':isStop_n,'em-offline':isOffline_n}">{{status_n_info}}</li>
          <li :class="{'em-run':isRun_s,'em-stop':isStop_s,'em-offline':isOffline_s}">{{status_s_info}}</li>   <!-- <li :class="[status_s ? 'em-run':'em-stop']"> -->
        </ul>

      </div>
      <div class="no-bd">
        <ul>
          <li style="list-style-type: none;font-family: 微软雅黑; font-weight: bold">1#提升机运行监控</li>
          <li style="list-style-type: none;font-family: 微软雅黑; font-weight: bold">2#提升机运行监控</li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";

export default {
  name: "runningStatus",
  mixins: [EmCommonApi],

  data() {
    return {
      isRun_n: false,
      isStop_n: false,
      isOffline_n: false,

      isRun_s: false,
      isStop_s: false,
      isOffline_s: false,

      status_n: 0,
      status_s: 0,
      status_n_info: "OFFINE",
      status_s_info: "OFFINE",
    }
  },
  created() {
    this.getRemoteData()
  },
  mounted() {
    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
    },  5000);
  },

  methods: {
    testData() {
          this.status_n = 1

          if(this.status_n == 1){
            this.status_n_info = "RUNNING";
            this.isRun_n = true;
            this.isStop_n = false;
            this.isOffline_n = false;
          }else if(this.status_n == 0){
            //注意：鲍店0是停车
            this.status_n_info = "STOP";
            this.isRun_n = false;
            this.isStop_n = true;
            this.isOffline_n = false;
          }else{
            this.status_n_info = "OFFLINE";
            this.isRun_n = false;
            this.isStop_n = false;
            this.isOffline_n = true;
          }


          this.status_s = 0;

          if(this.status_s == 1){
            this.status_s_info = "RUNNING";
            this.isRun_s = true;
            this.isStop_s = false;
            this.isOffline_s = false;
          }else if(this.status_s == 0){
            //注意：鲍店0是停车
            this.status_s_info = "STOP";
            this.isRun_s = false;
            this.isStop_s = true;
            this.isOffline_s = false;
          }else{
            this.status_s_info = "OFFLINE";
            this.isRun_s = false;
            this.isStop_s = false;
            this.isOffline_s = true;
          }
    },


    getRemoteData() {
      //注意：运算结果是停车/在线
      //鲍店/赵楼：有1个是0则判断为停车

      //鲍店
      //电气停车回路_北车 ns=1;s=1.425.1.0.0.0
      //安全回路_北车    ns=1;s=1.428.1.0.0.0
      //赵楼
      //电气停车回路_北车 ns=1;s=t|电气停车OK=1,No=2_北车
      //安全回路_北车    ns=1;s=t|安全回路状态OK=1,No=2_北车

      //鲍店
      //电气停车回路_南车 ns=1;s=1.373.1.0.0.0
      //安全回路_南车    ns=1;s=1.372.1.0.0.0
      //赵楼
      //电气停车回路_南车 ns=1;s=t|电气停车OK=1,No=2_南车
      //安全回路_南车    ns=1;s=t|安全回路状态OK=1,No=2_南车


      const _api = this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getRunningStatus"
      // console.log("运行状态url：")
      // console.log(_api)
      this.$_emApiMixin_get(_api)
          .then(res => {
            console.log("设备运行状态取回的数据：")
            console.log(res)

            this.status_n = parseInt(res[0].value) * parseInt(res[1].value)

            console.log("北车状态：" + this.status_n)
            console.log(res[0].value);
            console.log(res[1].value);
            if(this.status_n == 1){
              this.status_n_info = "RUNNING";
              this.isRun_n = true;
              this.isStop_n = false;
              this.isOffline_n = false;
            }else if(this.status_n == 0){
              //注意：鲍店0是停车
              this.status_n_info = "STOP";
              this.isRun_n = false;
              this.isStop_n = true;
              this.isOffline_n = false;
            }else{
              this.status_n_info = "OFFLINE";
              this.isRun_n = false;
              this.isStop_n = false;
              this.isOffline_n = true;
            }


            this.status_s = parseInt(res[2].value)  * parseInt(res[3].value)
            console.log("南车状态：" + this.status_s)
            console.log(res[2].value);
            console.log(res[3].value);
            if(this.status_s == 1){
              this.status_s_info = "RUNNING";
              this.isRun_s = true;
              this.isStop_s = false;
              this.isOffline_s = false;
            }else if(this.status_s == 0){
              //注意：鲍店0是停车
              this.status_s_info = "STOP";
              this.isRun_s = false;
              this.isStop_s = true;
              this.isOffline_s = false;
            }else{
              this.status_s_info = "OFFLINE";
              this.isRun_s = false;
              this.isStop_s = false;
              this.isOffline_s = true;
            }
          })

    },

  },
  beforeDestroy() {
    clearInterval(this.fresh);
  },
}
</script>

<style lang="scss" scoped>

.no {
  background-color: rgba(101, 132, 226, 0.1);
  padding: 1.5rem;
}
.no .no-hd {
  position: relative;
  border: 1px solid rgba(25, 186, 139, 0.17);
}
.no .no-hd::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 1.375rem;
  height: 1.125rem;
  border-top: 2px solid #02a6b5;
  border-left: 2px solid #02a6b5;
  content: '';
}
.no .no-hd::after {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 1.375rem;
  height: 1.125rem;
  border-bottom: 2px solid #02a6b5;
  border-right: 2px solid #02a6b5;
  content: '';
}



.no .no-hd ul {
  display: flex;
}

.no .no-hd ul li {
  padding-top: 1rem;
  list-style-type: none;
  position: relative;
  flex: 1;
  line-height: 3rem;    /*边框大小*/
  font-size: 3.5rem;  /*数字字体大小*/
  /*color: #ffeb7b;*/   /*这里屏蔽，改在动画变颜色*/
  text-align: center;
  font-family: electronicFont;
}
.no .no-hd ul li:first-child::after {
  content: '';
  position: absolute;
  top: 25%;
  right: 0;
  height: 50%;
  width: 1px;
  background-color: rgba(255, 255, 255, 0.3);
}
.no .no-bd ul {
  display: flex;
}
.no .no-bd ul li {
  flex: 1;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 2rem;  /*中间数字字体下的说明文字大小*/
  height: 1.5rem;
  line-height: 1.5rem;
  padding-top: 1.125rem;
}


/*文字闪烁动画*/
@-webkit-keyframes twinkling{	/*透明度由0到1*/
  0%{
    opacity:0;				/*透明度为0*/
  }
  100%{
    opacity:1;				/*透明度为1*/
  }
}

@-webkit-keyframes breathe {   /*带边框的呼吸灯效果动画*/
  0% {
    opacity:.2;
    box-shadow:0 1px 2px rgba(255,255,255,0.1);
  }
  100% {
    opacity:1;
    border:1px solid rgba(59,235,235,1);
    box-shadow:0 1px 30px rgba(59,255,255,1);
  }
}
.em-stop{
  color:#ff0000;
  -webkit-animation: twinkling 1s infinite ease-in-out;
}
.em-offline{
  color:#FFFF00;   /*黄色*/
  -webkit-animation: twinkling 1s infinite ease-in-out;
}
.em-run{
  color:#00A600;
}

/*液晶数字字体*/
@font-face {
  font-family: electronicFont;
  src: url("../../../../assets/font/DS-DIGIT.TTF");
}

</style>
